var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalanx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 1046 245.72",
    width: 1046,
    height: 245.72,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g6",
    transform: "translate(-152,-413.18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect8",
    x: 1143.11,
    y: 600.01001,
    width: 54.889999,
    height: 54.889999
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "m 298.49,520.72 v -33.5 H 152 v 33.5 h 41.16 v 85 c 0,32.86 16.58,51.59 50.36,51.59 a 137.13,137.13 0 0 0 43,-7.38 l -0.31,-30.08 a 98,98 0 0 1 -30.71,4.9 c -20,0 -19.66,-12.89 -19.66,-28.56 v -75.47 h 62.65 m 208.8,134.18 h 42.07 V 413.18 h -42.07 z m 175.05,-42.38 c -6.76,8.91 -16.89,14.74 -30.1,14.74 -15.66,0 -27.64,-6.14 -27.64,-20.26 0,-25.5 28.87,-26.42 48.21,-26.42 h 18.74 c 0,12.9 -2.15,22.42 -9.21,31.94 m -23,-127.45 c -18.43,0 -46.08,5.83 -57.74,11.05 v 29.18 c 11.36,-3.69 34.09,-9.21 52.51,-9.21 25.5,0 37.48,9.52 37.48,38.69 h -24 c -18.11,0 -39.3,1.54 -55.89,9.52 -16.27,8 -28.24,20.59 -28.24,45.15 0,31.64 28.55,49.45 58,49.45 19.66,0 41.16,-10.44 51.29,-28.57 h 0.62 v 24.58 h 37.47 V 555.09 C 730.87,506 710,485.07 659.31,485.07 Z M 926.42,654.9 V 550.17 c 0,-37.46 -16.89,-65.1 -56.51,-65.1 -22.42,0 -40.85,7.37 -54.36,26.41 h -0.61 v -22.42 h -39 V 654.9 h 41.16 v -81.07 c 0,-21.19 6.76,-55.28 38.08,-55.28 27.64,0 27.94,27.64 27.94,47.91 v 88.44 h 43.31 m 194.56,0 -59.88,-87.53 52.21,-78.31 h -43.6 l -32.45,54.2 -33,-54.2 h -51 l 54.41,78.94 -57.74,86.92 h 45.14 l 37,-60.5 37.29,60.5 H 1121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "m 414.89,612.52 c -6.76,8.91 -17.2,14.74 -30.4,14.74 -15.36,0 -27.34,-6.14 -27.34,-20.26 0,-25.5 28.56,-26.42 47.91,-26.42 h 18.74 c 0,12.9 -1.84,22.42 -8.91,31.94 M 391.55,485.07 c -18.11,0 -45.76,5.83 -57.73,11.05 v 29.18 c 11.36,-3.69 34.39,-9.21 52.82,-9.21 25.18,0 37.16,9.52 37.16,38.69 h -23.66 c -18.11,0 -39.3,1.54 -55.88,9.52 -16.58,7.98 -28.26,20.59 -28.26,45.15 0,31.64 28.56,49.45 58.05,49.45 19.65,0 41.15,-10.44 51.28,-28.57 H 426 l -0.31,24.58 h 37.47 V 555.09 C 463.11,506 442.23,485.07 391.55,485.07 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalanx);
export default __webpack_public_path__ + "static/media/talanx.0a51f15db01f3d5a46dad3a21ea81ebf.svg";
export { ForwardRef as ReactComponent };